import { render, staticRenderFns } from "./SummaryByChannel.vue?vue&type=template&id=c01c825a&scoped=true&"
import script from "./SummaryByChannel.vue?vue&type=script&lang=js&"
export * from "./SummaryByChannel.vue?vue&type=script&lang=js&"
import style0 from "./SummaryByChannel.vue?vue&type=style&index=0&id=c01c825a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01c825a",
  null
  
)

export default component.exports